// TODO: CHAIR-19112 Keep or remove this file and usages after test finishes
import createDomElement from 'chairisher/util/dom';

import { getAmplitudeExperimentFlagMap } from 'chairisher/context/experiments';
import { getGoogleSigninClientId, isGoogleSigninSdkLoaded, setGoogleSigninSdkLoaded } from 'chairisher/context/google';
import { isExperimentVariantB } from 'chairisher/thirdparty/experiments';
import { isTosAccepted, renderDefaultErrorOnTosField } from 'chairisher/view/helper/tosfield';

const GOOGLE_SIGNIN_JSSDK_SCRIPT_ID = 'gmail-jssdk';

let loginOrCreateForm = null;

const googleLoginCallback = (response) => {
    loginOrCreateForm.querySelector('[name="google_token"]').value = response.credential;
    loginOrCreateForm.querySelector('[name="is_provider_initial_attempt"]').value = 1;
    loginOrCreateForm.requestSubmit();
};

/**
 * Initializes the Google SDK
 * @see https://developers.google.com/identity/gsi/web/reference/js-reference#IdConfiguration
 */
function initGoogleSDK() {
    try {
        window.google.accounts.id.initialize({
            client_id: getGoogleSigninClientId(),
            ux_mode: 'popup',
            callback: googleLoginCallback,
        });
        setGoogleSigninSdkLoaded(true);
    } catch (e) {
        setGoogleSigninSdkLoaded(false);
    }
}

/**
 * Renders the Google Sign-in button which should only be called after the SDK has been initialized
 */
function renderSignInButton() {
    const buttonDiv = document.querySelector('.js-google-sign-in-wrapper');
    const { id: IdentityApi } = window.google.accounts;
    IdentityApi.renderButton(buttonDiv, {
        logo_alignment: 'center',
        shape: 'rectangular',
        text: 'continue_with',
        theme: 'outline',
    });

    // TODO: jkwok move this to pages where google button is not displayed
    // Display One Tap prompt
    // IdentityApi.prompt();
}

/**
 * Asynchronously loads Google SDK
 */
function injectGoogleSignInSdkScript() {
    if (!document.getElementById(GOOGLE_SIGNIN_JSSDK_SCRIPT_ID) || !isGoogleSigninSdkLoaded()) {
        const firstScript = document.getElementsByTagName('script')[0];
        const googleSigninScript = createDomElement('script', {
            attributes: {
                async: true,
                id: GOOGLE_SIGNIN_JSSDK_SCRIPT_ID,
                src: 'https://accounts.google.com/gsi/client',
            },
        });
        googleSigninScript.onload = () => {
            initGoogleSDK();
            renderSignInButton();
        };
        firstScript.parentNode.insertBefore(googleSigninScript, firstScript);
    } else if (!document.querySelector('.js-google-sign-in-wrapper').querySelector('div[role="button"]')) {
        renderSignInButton();
    }
}

/**
 * Binds Google Sign-in buttons with event listeners
 */
function bindGoogleSigninButtons() {
    // select all unbound Google sign-in buttons
    const googleBtns = document.querySelectorAll('.js-btn-google-sign-in:not(.js-is-bound)');

    googleBtns.forEach((button) => {
        const btn = button;
        btn.disabled = true;

        btn.addEventListener('click', ({ currentTarget: clickedBtn }) => {
            loginOrCreateForm = clickedBtn.closest('form');

            if (isTosAccepted(loginOrCreateForm)) {
                const submitBtn = loginOrCreateForm.querySelector('button[type="submit"]');
                submitBtn.disabled = true;

                document.querySelector('.js-google-sign-in-wrapper').querySelector('div[role="button"]').click();
            } else {
                renderDefaultErrorOnTosField(loginOrCreateForm);
            }
        });

        // re-enable the newly bound buttons
        btn.disabled = false;

        // prevent double binding through exclusion
        btn.classList.add('js-is-bound');
    });
}

/**
 * Entrypoint for Google Sign-in button where SDK gets initialized, and button is rendered with handlers if in treatment
 */
export default function renderGoogleSignin() {
    console.info(
        'in Google social auth - will experiment run:',
        isExperimentVariantB(getAmplitudeExperimentFlagMap().GMAIL_SOCIAL_LOGIN),
    );
    if (isExperimentVariantB(getAmplitudeExperimentFlagMap().GMAIL_SOCIAL_LOGIN)) {
        injectGoogleSignInSdkScript();
        bindGoogleSigninButtons();

        // show the button
        document.querySelector('.js-btn-google-sign-in-container').classList.remove('hidden');
    }
}
